import { paymentErrorMessage } from '@/lib/paymentSafety';

export const CREDIT_PRICING_CHANGED_REASON = 'credit_pricing_changed';

export class CreditPricingChangedError extends Error {
  readonly reason = CREDIT_PRICING_CHANGED_REASON;

  constructor(message: string) {
    super(message);
    this.name = 'CreditPricingChangedError';
  }
}

export function creditCheckoutResponseError(input: {
  httpStatus: number;
  payload: unknown;
  language: string;
  fallback: string;
}): Error {
  const record = input.payload && typeof input.payload === 'object'
    ? input.payload as Record<string, unknown>
    : {};
  const message = paymentErrorMessage(input.payload, input.language, input.fallback);
  return input.httpStatus === 409 && record.reason === CREDIT_PRICING_CHANGED_REASON
    ? new CreditPricingChangedError(message)
    : new Error(message);
}

export function isCreditPricingChangedError(
  error: unknown,
): error is CreditPricingChangedError {
  return error instanceof CreditPricingChangedError;
}

export async function recoverCreditPricingChange(actions: {
  closeConfirmation: () => void;
  clearPaymentForm: () => void;
  resetConfirmation: () => void;
  invalidateQuote: () => Promise<unknown>;
  refetchQuote: () => Promise<unknown>;
  notifyCustomer: () => void;
}): Promise<void> {
  actions.closeConfirmation();
  actions.clearPaymentForm();
  actions.resetConfirmation();
  actions.notifyCustomer();
  await actions.invalidateQuote();
  await actions.refetchQuote();
}
